import { Alert, Typography } from '@mui/material';

interface WarningBoxProps {
  title: string;
  description?: string;
}

export function WarningBox({ title, description }: WarningBoxProps) {
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 'medium',
          mb: 0.5,
        }}
      >
        {title}
      </Typography>
      {description}
    </Alert>
  );
}
